<template>
    <div>
        <!-- <assess-report :IsDetails="IsDetails" ref="assessReport" v-if="reportType !== 2"/>
        <contrast-report :IsDetails="IsDetails" ref="contrastReport" v-else/> -->
        <!-- 校级团体报告 -->
        <SchoolLevelSet :key="$store.getters['organization/getReportInfo'].id" :IsDetails="IsDetails" ref="secondItem" v-if="reportType == 1"></SchoolLevelSet>
        <!-- 区域团体报告 -->
        <AreaSet :key="$store.getters['organization/getReportInfo'].id" :IsDetails="IsDetails" ref="secondItem" v-if="reportType == 2"></AreaSet>
        <!-- 单校对比报告 -->
        <SingleSchoolSet :key="$store.getters['organization/getReportInfo'].id" :IsDetails="IsDetails" ref="secondItem" v-if="reportType == 3"></SingleSchoolSet>
        <!-- 多校对比报告 -->
        <MultipleSchoolSet :key="$store.getters['organization/getReportInfo'].id" :IsDetails="IsDetails" ref="secondItem" v-if="reportType == 4"></MultipleSchoolSet>

        <div v-if="!IsDetails" style="text-align: right;margin: 30px 0;padding-right: 50px;">
            <a-button @click="$parent.$data.current = 0" style="margin-right: 20px;">上一步</a-button>
            <a-button type="primary" @click="next">下一步</a-button>
        </div>
    </div>
</template>

<script>
    // import AssessReport from "../../components/AssessReport"
    // import ContrastReport from "../../components/ContrastReport"
    import SchoolLevelSet from "../../components/SchoolLevelSet"
    import AreaSet from "../../components/AreaSet"
    import SingleSchoolSet from "../../components/SingleSchoolSet"
    import MultipleSchoolSet from "../../components/MultipleSchoolSet"
    import $Bus from "@/pages/projectImpl/js/eventBus"

    export default {
        name: "StepsSecond",
        props:{
          IsDetails: {
              type: Boolean,
              default: false
          },
        },
        components: {
            SchoolLevelSet,
            AreaSet,
            SingleSchoolSet,
            MultipleSchoolSet
        },
        data() {
            return {
                boxSpinning: false,
                reportType: this.$store.getters['organization/getReportInfo'].reportType,
                reportInfo:this.$store.getters['organization/getReportInfo'],
                // reportType: 2,
                contrastReportChildrenLength: 0
            }
        },
        mounted(){
            $Bus.$on("contrastReportChildrenLength",index => {
                if (index){
                    this.contrastReportChildrenLength += index;
                }
            })
        },
        methods: {
            next() {
                this.$message.destroy();
                if([1,3].includes(this.reportType) && !this.$refs.secondItem.$data.organizationId){
                    this.$message.error('请选择机构');
                    return
                }
                if (!this.verification()) {
                    return
                }
                if(this.reportType == 1){
                    this.$store.commit("organization/setReportInfo", {
                        ...this.$store.getters['organization/getReportInfo'],
                        orgId:this.$refs.secondItem.$data.organizationId
                    });
                }
                if([2,3].includes(this.reportType)){
                    this.$store.commit("organization/setReportInfo", {
                        ...this.$store.getters['organization/getReportInfo'],
                        tableDataSource:this.$refs.secondItem.tableRelevant.tableDataSource
                    });
                }
                this.$parent.$data.current = 2;
            },
            verification(){
                const data = this.$refs.secondItem.tableRelevant.tableDataSource;
                switch (this.reportType){
                    case 1:
                        if(!data.length){
                            this.$message.error('请添加测评');
                            return false
                        }
                        if (!data.some(s => s.settingUserCount > 0)) {
                            this.$message.error('所有测评均未配置学生，请配置后再操作');
                            return false
                        }
                        break;
                    case 2:
                        if(!data.length){
                            this.$message.error('请添加测评');
                            return false
                        }
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].settingUserCount <=0){
                                this.$message.error(data[i].organizationName + '未配置学生，请配置后再操作');
                                return false
                            }
                        }
                        break;
                    case 3:
                        for (let i = 0; i < data.length; i++) {
                            if (!data[i].items.length) {
                                this.$message.error(data[i].groupReportSampleName + '未添加测评，请配置后再操作');
                                return false
                            }
                            if (data[i].settingUserCount <=0){
                                const item = data[i].items.filter(f => f.settingUserCount <= 0)[0];
                                this.$message.error(data[i].groupReportSampleName + " - " + item.organizationName + '未配置学生，请配置后再操作');
                                return false
                            }
                        }
                        break;
                    case 4:
                        const arr = data.map(m => {
                            const obj = {groupReportSampleName: m.groupReportSampleName};
                            m.items.forEach(m1 => {
                                if (obj[m1.organizationName]){
                                    obj[m1.organizationName] += m1.settingUserCount
                                } else {
                                    obj[m1.organizationName] = m1.settingUserCount
                                }
                            });
                            return obj;
                        });
                        for (let i = 0; i < data.length; i++) {
                            if (!data[i].items.length) {
                                this.$message.error(data[i].groupReportSampleName + '未添加测评，请配置后再操作');
                                return false
                            }
                            for (let key in arr[i]){
                                if (arr[i][key] <= 0){
                                    this.$message.error(arr[i].groupReportSampleName + " - " + key + '未添加测评，请配置后再操作');
                                    return false
                                }
                            }
                        }
                        break;
                }
                return true
            }
        }
    }
</script>

<style scoped>

</style>